import { makeRequest } from 'services/utils';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { objectToArray } from 'UI/utils';

const {
  BulkSequencesAddSteps,
  BulkSequencesCancelSequence,
  BulkSequencesCancelSequenceStep,
  BulkSequencesEditStep,
  BulkSequencesTriggerDays
} = Endpoints;

const { errors: errorCopies, success: successCopies } = strings.bulkEmails;

export const getBulkSequencesRecommendedDays = () =>
  makeRequest({
    method: 'get',
    url: BulkSequencesTriggerDays,
    alertConfig: {
      error: {
        title: errorCopies.gettingSequencesTriggerDays
      }
    }
  });

const ID_KEYS = {
  bulk: ':bulkId',
  step: ':stepId'
};

const endpointReplacer = ({ endpoint, bulkId, stepId }) =>
  endpoint.replace(
    new RegExp(objectToArray(ID_KEYS).join('|'), 'g'),
    matchedKey => ({ [ID_KEYS.bulk]: bulkId, [ID_KEYS.step]: stepId }[matchedKey])
  );

export const addSequenceSteps = ({ bulkId, steps }) =>
  makeRequest({
    method: 'post',
    data: {
      bulk_sequences: steps
    },
    endpointOptions: {
      path: BulkSequencesAddSteps,
      replaceId: bulkId
    },
    alertConfig: {
      success: successCopies.addSequenceStep,
      error: errorCopies.addSequenceStep
    }
  });

export const editSequenceStep = ({ bulkId, delayDays, emailBody, stepId, subject, text }) =>
  makeRequest({
    method: 'put',
    data: {
      html: emailBody,
      sending_after_next_days: delayDays,
      subject,
      text
    },
    url: endpointReplacer({ endpoint: BulkSequencesEditStep, bulkId, stepId }),
    alertConfig: {
      success: successCopies.updateSequenceStep,
      error: errorCopies.editSequenceStep
    }
  });

export const cancelSequence = sequenceId =>
  makeRequest({
    method: 'post',
    endpointOptions: {
      path: BulkSequencesCancelSequence,
      replaceId: sequenceId
    },
    alertConfig: {
      success: successCopies.cancelSequence,
      error: errorCopies.cancelSequence
    }
  });

export const cancelSequenceStep = ({ bulkId, stepId }) =>
  makeRequest({
    method: 'post',
    url: endpointReplacer({ endpoint: BulkSequencesCancelSequenceStep, bulkId, stepId }),
    alertConfig: {
      success: successCopies.cancelSequenceStep,
      error: errorCopies.cancelSequenceStep
    }
  });
